<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="550px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Dollar Price') }}</span>
            </v-layout>
          </h3>

          <v-spacer />

          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 class="pa-2">
              <div class="caption no-select">
                {{ `${$t('Last Price')} (${systemCurrency})` }}
              </div>
              <strong>{{ lastDollarPrice | currency }}</strong>
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-text-field
                id="dollar-focus-me"
                v-model="todayPrice"
                :label="`${$t('Today Price')} (${systemCurrency}) *`"
                name="dollar_price"
                box
                hide-details
                background-color="white"
                :error="errors.has('dollar_price')"
                v-validate="'required|numeric|min_value:1'"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'add-component',
  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {
        todayPrice: null
      },
      keepForm: false
    }
  },
  computed: {
    ...mapGetters({
      lastDollarPrice: 'dollarRates/getLastDollarPrice',
      userData: 'auth/getAuthUserData'
    }),
    todayPrice: {
      get() {
        return this.form.todayPrice === null ? this.lastDollarPrice : this.form.todayPrice
      },
      set(val) {
        this.form.todayPrice = val
      }
    }
  },
  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },
  created() {
    this.fetchLastDollarPrice()
  },
  methods: {
    ...mapActions({
      addDollarPrice: 'dollarRates/addDollarPrice',
      fetchLastDollarPrice: 'dollarRates/fetchLastDollarPrice'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('dollar-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('user_id_fk', this.userData.user_id)

            // for (let pair of formData.entries()) {
            //   console.warn(`${pair[0]}: ${pair[1]}`)
            // }

            this.addDollarPrice(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
                this.fetchLastDollarPrice()
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
